function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconReTraditionFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4c-1.048 0-2.152.096-3.137.365l-.526-1.93C13.552 2.104 14.847 2 16 2c6.575 0 12.273 4.73 13.675 10.878l-1.95.444C26.527 8.07 21.625 4 16 4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6 12.8L29 16l1.5-3.7-3.9.5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56 21.99C2.71 17.112 3.811 10.925 7.781 7.232L6.419 5.768C1.79 10.074.49 17.284 3.837 23.005l.005.01a14.95 14.95 0 002.25 2.892l1.415-1.414A12.949 12.949 0 015.56 21.99z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.4l1.5-3.7-3.9.6L8 8.4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.468 21.945c.512-.769.878-1.75 1.167-2.808l1.93.526c-.31 1.132-.739 2.341-1.417 3.367-3.339 5.682-10.212 8.264-16.254 6.322l.612-1.904c5.148 1.655 11.065-.553 13.93-5.453l.015-.025.017-.025z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 26.7l-4 .5 2.4 3.2 1.6-3.7z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 9h2l-.178.355a.999.999 0 00-.086.645h7.527a1 1 0 00-.086-.645L19.5 9h2l.177.355a1 1 0 01-.187 1.155L21 11c0 .21.188.729.663 1.246.463.505.965.754 1.337.754v2h-2v3h1.5v1c0 .308.212.834.638 1.335.198.234.407.418.59.536a.838.838 0 00.271.128c.004.001.004.001.001.001v2H8v-2c-.003 0-.003 0 0 0a.837.837 0 00.272-.13c.183-.117.392-.301.59-.535.418-.492.63-1.009.638-1.319V18H11v-3H9v-2c.372 0 .874-.249 1.337-.754C10.81 11.73 11 11.21 11 11l-.49-.49a1 1 0 01-.188-1.155L10.5 9zm.828 11a4.655 4.655 0 01-.48 1h10.303a4.655 4.655 0 01-.48-1h-3.474L16 19.202 14.803 20h-3.475zM19 18h-1.197L16 16.798 14.197 18H13v-3h6v3zm.192-6c.127.348.31.688.523 1h-7.43c.213-.312.396-.652.523-1h6.384z",
    fill: props.color
  }));
}

export default SvgIconReTraditionFilled;